module.exports = __webpack_public_path__ + "assets/img/picture3.0ae3af39.png";